import { createReducer, on } from '@ngrx/store';
import { clearOrderCount, incrementOrderCount, setDataUpdates, setOrderCount, clearSurveyCount, incrementSurveyCount, setSurveyCount } from './menu.actions';
import { MenuProp } from './menu.prop';

export const initialState: MenuProp = {
  has_data_updates: false,
  orders_count: 0,
  surveys_count: 0
};

const _menuReducer = createReducer(
  initialState,
  on(setDataUpdates, (state, value) => {
    return {
      ...state,
      has_data_updates: value.has_data_updates
    };
  }),
  on(incrementOrderCount, (state) => {
    return {
      ...state,
      orders_count: state.orders_count+1
    }
  }),
  on(clearOrderCount, (state) => {
    return {
      ...state,
      orders_count: 0
    }
  }),
  on(setOrderCount, (state, value) => {
    return {
      ...state,
      orders_count: value.orders_count
    }
  }),
  on(incrementSurveyCount, (state) => {
    return {
      ...state,
      surveys_count: state.surveys_count+1
    }
  }),
  on(clearSurveyCount, (state) => {
    return {
      ...state,
      surveys_count: 0
    }
  }),
  on(setSurveyCount, (state, value) => {
    return {
      ...state,
      surveys_count: value.surveys_count
    }
  })
);

export function menuReducer(state, action) {
  return _menuReducer(state, action);
}